<template>
  <div class="layout-menu-list">
    <ul class="link-wrap noselect">
      <MenuItem v-for="(opt, i) in list" :key="opt.url+i" :data="opt" :remindShow="opt.remindShow" />
    </ul>
  </div>
</template>

<script>
  import MenuItem from './menu-item'
  export default {
    props: {
      list: {
        type: Array,
        default: () => ([])
      }
    },
    components: {MenuItem},
  }
</script>

<style lang="scss" scoped>
 .layout-menu-list {
  flex: 1;
  padding-top: 10px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 3px;
    background-color: rgba($color: #000000, $alpha: 0.2);
    border: 1px solid white;
  }

  &::-webkit-scrollbar-track {
    border: 0 solid transparent;
    background-color: #fff;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  .link-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -8px;
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-list/index.vue